module.exports = __webpack_public_path__ + "static/img/a033.8cf3557.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a033.jpg
// module id = HYgD
// module chunks = 0